import * as React from 'react';
import Service from '@/app/utils/service';
import API from '@/app/api/internalAPIs';
import { CollaborationTemplateType } from '@/app/components/Worklist/types';
import { mapCollaborationTemplatesForUI } from '@/app/components/Worklist/service';

export const useWorklistTemplates = () => {
  const [collaborationTemplates, setCollaborationTemplates] = React.useState(
    [],
  );
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  const loadAllTemplates = React.useCallback(() => {
    return Service.get(
      API.collaborationTemplates.all(undefined, true),
      (res: CollaborationTemplateType[]) => {
        setCollaborationTemplates(mapCollaborationTemplatesForUI(res));
        setLoading(false);
        setError('');
      },
      (err: any) => {
        setCollaborationTemplates([]);
        setLoading(false);
        setError(err);
      },
    );
  }, []);

  React.useEffect(() => {
    loadAllTemplates();
  }, []);

  return {
      collaborationTemplates,
      loading,
      error,
  };
};
